import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const SecurityFilledIcon: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" />
  </BlueprintIcon>
);
